import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { AdaptiveSwipe, ContainerWithFooter, PlanBox, Loader } from '../components';
import { StartFreeTrialModal, NoSubscriptionModal } from '../components/modals';
import { MainTitle } from '../components/styled';
import { createPricePlans, getProductFeatures, GroupTypesB2C, Period } from '../helpers/product';
import { redirectWithQueryParams, PagePath, redirectToLogin } from '../helpers/util';
import { onlyEssentialCountries } from '../config';
import { appActions } from '../store/ducks/app';
import { modalActions } from '../store/ducks/modal';

interface State {
  index: number;
}

const mapStateToProps = (state: any) => ({
  user: state.appData.user,
  locationQuery: state.router.location.query,
  loading: state.appData.loading,
  country: state.appData.country,
  general: state.appData.general,
  currency: state.appData.currency,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  loadUser: () => void;
  startFreeTrial: () => void;
  toggleNoSubscriptionModal: (isOpen: boolean) => void;
}

type Props = StateProps & DispatchProps;

class Plans extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      index: 0,
    };
  }

  async componentDidMount() {
    this.props.loadUser();
  }

  onChangeIndex = (index: number) => {
    this.setState({ index });
  };

  handleGoBack = () => {
    this.setState({ index: this.state.index - 1 });
  };

  handleGoNext = () => {
    this.setState({ index: this.state.index + 1 });
  };

  handleSelection = (groupType: GroupTypesB2C) => {
    if (groupType === GroupTypesB2C.FREE_TRIAL) {
      if (this.props.user) {
        this.props.startFreeTrial();
      } else {
        redirectToLogin();
      }
    } else {
      redirectWithQueryParams(PagePath.complete, this.props.locationQuery, { package: groupType, period: Period.YEARLY });
    }
  };

  onlyEssential = () => onlyEssentialCountries?.includes(this.props.country);

  freeTrialHidden = () => (this.props.user && !this.props.user.freeTrial) || this.props.locationQuery.origin === 'mobile' || this.onlyEssential();

  render() {
    if (this.props.loading && !this.props.general) {
      return <Loader />;
    }
    return (
      <ContainerWithFooter>
        <MainTitle>
          <FormattedMessage id="plan_that_fits_title" values={{ br: <br /> }} />
        </MainTitle>
        <AdaptiveSwipe
          index={this.state.index}
          onChangeIndex={this.onChangeIndex}
          onNextArrowClick={this.handleGoNext}
          onBackArrowClick={this.handleGoBack}
        >
          <PlanBox
            nameKey={GroupTypesB2C.FREE_TRIAL}
            features={getProductFeatures(GroupTypesB2C.PREMIUM)}
            buttonTitleKey="start_free_trial"
            onButtonClick={() => this.handleSelection(GroupTypesB2C.FREE_TRIAL)}
            swipeable={true}
            hidden={this.freeTrialHidden()}
          />
          <PlanBox
            nameKey="essential_plan"
            features={getProductFeatures(GroupTypesB2C.ESSENTIAL)}
            buttonTitleKey="go_essential"
            onButtonClick={() => this.handleSelection(GroupTypesB2C.ESSENTIAL)}
            swipeable={true}
            hidden={false}
            price={createPricePlans(GroupTypesB2C.ESSENTIAL, this.props.currency, this.props.general.config.currencies.prices)}
          />
          <PlanBox
            nameKey="premium_plan"
            features={getProductFeatures(GroupTypesB2C.PREMIUM)}
            buttonTitleKey="go_premium"
            onButtonClick={() => this.handleSelection(GroupTypesB2C.PREMIUM)}
            swipeable={true}
            hidden={this.onlyEssential()}
            price={createPricePlans(GroupTypesB2C.PREMIUM, this.props.currency, this.props.general.config.currencies.prices)}
          />
        </AdaptiveSwipe>
        <StartFreeTrialModal />
        <NoSubscriptionModal />
      </ContainerWithFooter>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, { ...appActions, ...modalActions })(Plans);
